import { RouteComponentProps } from "react-router-dom"
import ProjectChat from "../../../projects/components/ProjectChat"

type RouteParams = { projectId: string }

const ProjectChatRoute = ({ match }: RouteComponentProps<RouteParams>) => {
  return <ProjectChat projectId={match.params.projectId} />
}

export default ProjectChatRoute
